import React from 'react';
import { Modal } from 'antd';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import Chat from './Chat/ChatContainer';
import Notes from './Notes/NotesContainer';
import * as actions from '../../store/actions';
import * as streamActions from '../../store/actions/InterviewRecordingActions';
import NTInterviewVideoContainer from '../../components/Interview/NTInterviewVideoContainer.js';
import MeetingControlBar from '../../components/Meeting/MeetingControlBar.js';
import ScreenShareView from '../Interview/Meeting/ScreenShareView.js';
import { isInterviewDeveloper } from '../../helperFunctions';
import { useInterviewCommonLogic } from '../../hooks/useInterviewCommonLogic';

const NonTechnicalInterviewContainer = props => {
  const {
    chat,
    currOption,
    setCurrOption,
    isWSConnected,
    isScreenShareView,
    curr_note,
    setCurrNoteState,
    inactivityModalVisible,
    countdown,
    contextHolder,
    sendMessage,
    toggleView,
    handleRecoveryModalOk,
    handleContinue,
    handleDisconnect,
  } = useInterviewCommonLogic(props);

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        height: 'calc(100vh - 85px)',
        overflow: 'hidden',
      }}
    >
      <div style={{ flex: 1, overflow: 'hidden' }}>
        {isScreenShareView ? (
          <ScreenShareView />
        ) : (
          <div
            style={{
              height: '100%',
              display: 'flex',
              flexDirection: 'row',
              boxSizing: 'border-box',
              overflow: 'hidden',
              gap: '16px',
            }}
          >
            <div
              style={{
                flex: 1,
                background: '#202124',
                overflow: 'hidden',
                minWidth: 0,
              }}
            >
              <NTInterviewVideoContainer />
            </div>

            {/* Sidebar for chat/notes */}
            {(currOption === 'chat' || currOption === 'notes') && (
              <div
                style={{
                  width: '400px',
                  height: '100%',
                  background: 'transparent',
                  borderRadius: '8px',
                  overflow: 'hidden',
                  display: 'flex',
                  flexDirection: 'column',
                }}
              >
                <div style={{ padding: '16px', height: '100%', overflow: 'hidden' }}>
                  {currOption === 'chat' && (
                    <Chat
                      sendMessage={sendMessage}
                      chat={chat}
                      connected={isWSConnected}
                      chat_data={props.chat_data}
                      unreadCount={props.unreadCount}
                    />
                  )}
                  {currOption === 'notes' && (
                    <Notes
                      curr_note={curr_note}
                      setCurrNoteState={setCurrNoteState}
                    />
                  )}
                </div>
              </div>
            )}
          </div>
        )}
      </div>
      <MeetingControlBar
        setCurrOption={setCurrOption}
        isDeveloper={isInterviewDeveloper(props.participants)}
        onScreenShareClick={() => toggleView()}
        onEndMeeting={() => props.endMeeting(isInterviewDeveloper(props.participants))}
        isScreenShareActive={isScreenShareView}
        currOption={currOption}
        interviewType={props.interview_type}
      />
      {contextHolder}
      {props.recoveryModalOpen && (
        <Modal
          title="Screen Share Stopped"
          open={props.recoveryModalOpen}
          onOk={handleRecoveryModalOk}
          closable={false}
          okText="Share Screen Again"
        >
          <p>Screen share stopped. Please share your screen again to continue.</p>
        </Modal>
      )}
      <Modal
        title={<div style={{ textAlign: 'center' }}>Interviewer left the meeting</div>}
        open={inactivityModalVisible}
        onOk={handleContinue}
        onCancel={handleDisconnect}
        okText="Continue Interview"
        cancelText="End Interview"
        closable={false}
        centered
      >
        <div style={{ textAlign: 'center' }}>
          <p>One or more attendees have left the meeting. Do you want to continue?</p>
          <p>
            Time remaining: <strong>{countdown}</strong> seconds
          </p>
        </div>
      </Modal>
    </div>
  );
};

const mapDispatchToProps = dispatch => {
  return {
    fetchInterviewInvite: (
      interview_id,
      hash_value,
      role,
      company_id,
      fetch_interview_data,
      callback,
    ) =>
      dispatch(
        actions.fetchInterviewInvite(
          interview_id,
          hash_value,
          role,
          company_id,
          fetch_interview_data,
          callback,
        ),
      ),
    fetchData: interview_id => dispatch(actions.fetchData(interview_id)),
    setEndInterviewUserDetail: user => dispatch(actions.setEndInterviewUserDetail(user)),
    setParticipants: participants => dispatch(actions.setParticipants(participants)),
    postNote: (data, callback) => dispatch(actions.postNote(data, callback)),
    checkNetworkConnection: () => dispatch(actions.checkNetworkConnection()),
    setHeartbeat: fire_time => dispatch(actions.setHeartbeat(fire_time)),
    setUnreadCount: count => dispatch(actions.setUnreadCount(count)),
    closeMediaRecoveryModal: () => dispatch(streamActions.closeMediaRecoveryModal()),
    initScreenStream: () => dispatch(streamActions.initScreenStream()),
    expireMeeting: (meetingId, isDeveloper) => {
      dispatch(actions.expireMeeting(meetingId, isDeveloper));
    },
  };
};

const mapStateToProps = state => {
  return {
    interview_id: state.interview.interview_id,
    interview_status: state.interview.status,
    interview_title: state.interview.title,
    interview_role: state.interview.role,
    interview_type: state.interview.interview_type,
    participants: state.interview.participants,
    start_time: state.interview.start_time,
    role: state.interview.role,
    user_id: state.auth.user_id,
    chat_data: state.events.chat_data,
    heartbeat: state.events.heartbeat,
    meetingSession: state.interviewRecording.meetingSession,
    unreadCount: state.events.unreadCount,
    recoveryModalOpen: state.interviewRecording.recoveryModalOpen,
    recoveryReason: state.interviewRecording.recoveryReason,
    meeting: state.meeting,
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(NonTechnicalInterviewContainer),
);
